module.exports = __webpack_public_path__ + "img/6F503E_D59A70_221812_B0A899-256px.c5414013.png";